import React, { createContext, useContext, ReactNode } from 'react';
import { useAuthentication } from '../hooks/useAuthentication';
import { AuthenticationPort } from '../../domain/ports/AuthenticationPort';
import { User } from '../../domain/entities/User';

interface AuthenticationContextType {
  user: User | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  signIn: (email: string, password: string) => Promise<void>;
  signOut: () => Promise<void>;
  updateCGUAcceptanceUser: (user: User) => Promise<void>;
}

const AuthenticationContext = createContext<AuthenticationContextType | undefined>(undefined);

interface AuthenticationProviderProps {
  children: ReactNode;
  authenticationPort: AuthenticationPort;
}

export const AuthenticationProvider: React.FC<AuthenticationProviderProps> = ({
  children,
  authenticationPort,
}) => {
  const authState = useAuthentication(authenticationPort);

  return (
    <AuthenticationContext.Provider value={authState}>
      {children}
    </AuthenticationContext.Provider>
  );
};

export const useAuthenticationContext = (): AuthenticationContextType => {
  const context = useContext(AuthenticationContext);
  if (context === undefined) {
    throw new Error('useAuthenticationContext must be used within an AuthenticationProvider');
  }
  return context;
};